var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header-nav',{on:{"changeContent":_vm.changeContent}}),_vm._v(" "),_c('div',{attrs:{"id":"logo"}}),_vm._v(" "),_c(_vm.currentComponent,{tag:"component"}),_vm._v(" "),_c('footer',[_c('span',[_vm._v("© 1999-2018 Maki Amayumi")]),_vm._v(" "),_c('social')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5703fd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 